module.exports = __webpack_public_path__ + "images/emoji/pensive.aa6990c9cf98f9ed18ce.png";